import { ACTIVE_REQUESTING_PLATFORM_ENV_VARIABLE_NAME, ALL_AVAILABLE_PLATFORMS_CODES } from '../constants/requesting-platform';

function getActiveRequestingPlatformFromEnv() {
  return process.env[ACTIVE_REQUESTING_PLATFORM_ENV_VARIABLE_NAME];
}

export const selectionToRequestingPlatformCode = (
  selection,
  availablePlatforms = [],
) => {
  if (!selection || selection === ALL_AVAILABLE_PLATFORMS_CODES) {
    return availablePlatforms;
  }
  return [selection];
};

export const parseRequestingPlatformSelectionFromHistory = (
  value,
  availablePlatforms = [],
) => {
  if (typeof value === 'string') {
    return value;
  }

  if (Array.isArray(value)) {
    if (!value.length) {
      return ALL_AVAILABLE_PLATFORMS_CODES;
    }

    const sortedCodes = [...value].sort().join(',');
    const sortedAvailable = [...availablePlatforms].sort().join(',');
    if (sortedCodes === sortedAvailable) {
      return ALL_AVAILABLE_PLATFORMS_CODES;
    }

    if (value.length === 1) {
      return value[0];
    }

    return ALL_AVAILABLE_PLATFORMS_CODES;
  }
  return ALL_AVAILABLE_PLATFORMS_CODES;
};

export default getActiveRequestingPlatformFromEnv;
